<template>
  <div class="index-agent">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3>Welcome, {{ agentSession.first_name }}</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Dashboard</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <div class="form-group form-focus">
                  <div class="btn-group btn-block">
                    <button
                      style="min-width: auto;"
                      type="button"
                      class="btn add-btn btn-block"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span v-if="!isLoadingImage"
                        ><i class="fa fa-download"></i> Download Image</span
                      >
                      <span v-else>...</span>
                    </button>
                    <button
                      style="min-width: auto;"
                      type="button"
                      class="btn add-btn dropdown-toggle dropdown-toggle-split"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        :disabled="isLoadingImage"
                        href="javascript:void(0)"
                        @click.prevent="downloadImagePNG()"
                        >PNG</a
                      >
                      <a
                        class="dropdown-item"
                        :disabled="isLoadingImage"
                        href="javascript:void(0)"
                        @click.prevent="downloadImageJPEG()"
                        >JPEG</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Page Header -->

          <div ref="downloadImage">
            <div class="row">
              <div class="col-md-12">
                <TotalKeywords />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="card card__custom-height">
                  <div class="card-body ">
                    <total-scrape-marketplace />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card card__custom-height">
                  <div class="card-body ">
                    <!-- Total Scrape per Status -->
                    <total-scrape-status />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="shopee" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="tokopedia" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="lazada" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="bukalapak" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Page Content -->
      </div>
      <!-- Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

import TotalScrapeMarketplace from "./components/totalScrapeMarketplaceAgent.vue";
import TotalScrapeStatus from "./components/totalScrapeStatusAgent.vue";
import TotalStatusPerMP from "./components/totalStatusPerMPAgent.vue";
import TotalKeywords from "./components/totalKeywordsAgent.vue";

import { mapGetters } from "vuex";

import { toPng, toJpeg } from "html-to-image";

export default {
  name: "MonitoringAgent",
  components: {
    LayoutHeader,
    LayoutSidebar,
    TotalScrapeMarketplace,
    TotalScrapeStatus,
    TotalStatusPerMP,
    TotalKeywords
  },
  data() {
    return {
      isLoadingImage: false
    };
  },
  computed: {
    ...mapGetters(["agentSession"])
  },
  methods: {
    async downloadImagePNG() {
      const el = this.$refs.downloadImage;
      const now = new Date();
      const unixTime = Math.floor(now.getTime() / 1000);

      if (el === null) {
        return;
      }

      this.isLoadingImage = true;

      await toPng(el, { backgroundColor: "#f7f7f7" })
        .then(dataUrl => {
          const link = document.createElement("a");
          link.download = `dashboard-monitoring-${unixTime}.png`;
          link.href = dataUrl;
          link.click();
        })
        .catch(err => {
          console.log(err);
        });

      this.isLoadingImage = false;
    },
    async downloadImageJPEG() {
      const el = this.$refs.downloadImage;
      const now = new Date();
      const unixTime = Math.floor(now.getTime() / 1000);

      if (el === null) {
        return;
      }

      this.isLoadingImage = true;

      await toJpeg(el, { backgroundColor: "#f7f7f7" })
        .then(dataUrl => {
          const link = document.createElement("a");
          link.download = `dashboard-monitoring-${unixTime}.jpeg`;
          link.href = dataUrl;
          link.click();
        })
        .catch(err => {
          console.log(err);
        });

      this.isLoadingImage = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/indexAgent.vue